import React from "react";
import Header from "./Header";
import TrdList from "../trd/TrdList";

export default function LayoutTrd() {
  return (
    <>
      <Header />
      <TrdList />
    </>
  );
}
